/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Money_PackInputs */

const en_start_page_money_pack = /** @type {(inputs: Start_Page_Money_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€360`)
};

const pl_start_page_money_pack = /** @type {(inputs: Start_Page_Money_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1350 zł`)
};

/**
* | output |
* | --- |
* | "€360" |
*
* @param {Start_Page_Money_PackInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_money_pack = /** @type {((inputs?: Start_Page_Money_PackInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Money_PackInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_money_pack(inputs)
	return en_start_page_money_pack(inputs)
});